import { CovSensorStatus, SoundSensorStatus } from "@eisox/api/core-api";
import { z } from "@eisox/zod";

import { covSensorPeriodSchema } from "../helpers";

export const functionsSettingsSchema = z.object({
  isSwitchEnabled: z.boolean(),
  isAutoPrecomf: z.boolean(),
  isPreComfRoom: z.boolean(),
  covSensorParam: z.object({
    status: z.enum(CovSensorStatus),
    periods: z.array(covSensorPeriodSchema).min(0).max(14),
  }),
  soundSensorParam: z.object({
    status: z.enum(SoundSensorStatus),
  }),
});

export type FunctionsSettingsSchemaType = z.infer<typeof functionsSettingsSchema>;
